import React from 'react'
import { Separator } from '@fs/zion-ui'
import FamilyColumnHeading from './FamilyColumnHeading'
import { useFamilyColumnValues } from '../../../contexts/FamilyColumnContext'
import FamilySkeleton from '../family/FamilySkeleton'
import ButtonsSkeleton from './ButtonsSkeleton'

export default function FamilyColumnSkeleton(): JSX.Element {
  const { type } = useFamilyColumnValues()

  return (
    <div>
      <FamilyColumnHeading type={type} />
      <FamilySkeleton />
      <Separator size="xxs" />
      {/* eslint-disable-next-line test-selectors/button -- NA */}
      <ButtonsSkeleton />
    </div>
  )
}
